import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { InputStaticFieldsComponent } from '../../input-static-fields/input-static-fields.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Validation } from '../../../common/validation/validation';
import { TranslationService } from '../../../services/translation/translation.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { ForgetPasswordService } from '../service/forget-password.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forget-password',
  imports: [InputStaticFieldsComponent, ReactiveFormsModule, CommonModule],
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent implements OnInit {

  forgetPasswordForm!: FormGroup;
  private translationService = inject (TranslationService);
  private loadingService = inject (LoaderService);
  private forgetService = inject (ForgetPasswordService);
  private router = inject (Router);
  Validation = Validation
  showErrorMessage:boolean=false;
  currentMessage!:string;
  @Output() modalDismiss = new EventEmitter<void>();

  constructor(public fb: FormBuilder) { }
  ngOnInit(): void {
    this.forgetPasswordForm = this.fb.group({
      email: ['', this.Validation.clinic.EMAIL.pattren]
    });
  }
  onSubmit(): void {     
    if (this.forgetPasswordForm.valid) {
      this.loadingService.showSpinner();
      this.forgetService.forgetPassword(this.forgetPasswordForm.value).subscribe(
        {
          next: (data: any) => {
            this.closeModal();
            this.router.navigateByUrl('/resetpassword');
            this.loadingService.stopSpinner();
          },
          error: (error: any) => {
            //error.error
            this.showErrorMessage = true;
            this.currentMessage= "No account found with this email address. Please try again.";
            this.loadingService.stopSpinner()
            setTimeout(() => {
              this.showErrorMessage = false;
            }, 5000);
          }
      });    
    }
  }
  closeModal() {
    this.modalDismiss.emit();
  }
  close() {
    this.showErrorMessage = false;
  }
  translate(key: string): string {
    return this.translationService.translate(key);
  }
}
